import { render, staticRenderFns } from "./UserTypeNotificationsTable.vue?vue&type=template&id=99e86648"
import script from "./UserTypeNotificationsTable.vue?vue&type=script&lang=js"
export * from "./UserTypeNotificationsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports